import { type DeviceType } from '../../types/DeviceType';
import { type Theme } from '../../types/Theme';
import { InteractionName } from '../../types/InteractionName';
import { panoramaClient } from '../../utils/panoramaClient/panoramaClient';
import { captureException } from '../../utils/errorReporter';
import { square } from './index';

export interface InitSquareAPIConfig {
  locationId: string;
  applicationId: string;
  deviceType: DeviceType;
  theme: Theme;
}

export async function initSquareAPI(config: InitSquareAPIConfig, onError?: (error: unknown) => void): Promise<void> {
  panoramaClient.transaction(InteractionName.SQUARE_SDK_INIT).start();

  try {
    await square.api.init(config);
  } catch (error) {
    onError?.(error);
    captureException(error, true);
  }

  panoramaClient.transaction(InteractionName.SQUARE_SDK_INIT).finish();
}
